import { v4 as uuidV4 } from 'uuid'
import { setCookie, removeCookie, getCookie } from './cookie'
import store from '@/store'
import { constantStrings, cookieConstant } from './constants'
import mqttClient from './aws-iot/mqtt'
import { getIdleTimeout, isUserLoggedIn } from './utils'
import AppLog from '@/services/errors/app-logs'

// We are using session as unique conversationId for User
class Session {
  constructor() {
    this.idleTimeout = null
    this.conversationId = null
    this.createdAt = null
  }

  init(conversationId, createdAt) {
    this.conversationId = conversationId
    this.createdAt = createdAt
  }

  getConversationId(jsonConfig) {
    this.idleTimeout = getIdleTimeout()
    if (this.checkIdleUser(this.idleTimeout) || !this.conversationId) {
      if(isUserLoggedIn())  {
        this.createAuthenticatedConversationID(store.state.authenticatedConversationId)
      } else {
        this.createNewConversation(jsonConfig)
      }
    }
    return this.conversationId
  }

  createAuthenticatedConversationID(conversationId) {
    this.idleTimeout = getIdleTimeout()
    this.createdAt = new Date().getTime()
    this.conversationId = conversationId
    updateCookie(this.conversationId, this.createdAt, this.idleTimeout)
    new AppLog({
      name: 'Create Authenticated ConversationId',
      message:`ConversationId inside the fn createAuthenticatedConversationID: ${this.conversationId}, conversationId inside cookie: ${getCookie(cookieConstant.SESSION.CONVERSATION_ID)}`,
      logLevel: 'info',
      service: 'Session'
    })
    mqttClient.createSubscription(this.conversationId)
    store.dispatch('clearChatsWithAgentDesk')
    store.dispatch('updateControlType', constantStrings.BOT) // to clear live agent on new session
  }

  createNewConversation(jsonConfig) {
    this.conversationId = jsonConfig?.fixedConversationId || uuidV4()
    this.createdAt = new Date().getTime()
    updateCookie(this.conversationId, this.createdAt, this.idleTimeout)
    new AppLog({
      name: 'Create New Conversation',
      message:`ConversationId inside the fn createNewConversation: ${this.conversationId}, conversationId inside cookie: ${getCookie(cookieConstant.SESSION.CONVERSATION_ID)}`,
      logLevel: 'info',
      service: 'Session'
    })
    mqttClient.createSubscription(this.conversationId)
    store.dispatch('clearChatsWithAgentDesk')
    store.dispatch('updateControlType', constantStrings.BOT) // to clear live agent on new session
  }

  checkIdleUser(idleTimeout) {
    const lastConversationCreatedAt = this.createdAt
    return lastConversationCreatedAt
      ? compareDates(
          new Date().getTime(),
          lastConversationCreatedAt,
          idleTimeout
        )
      : true
  }

  endConversation() {
    this.conversationId = null
    removeCookie(cookieConstant.SESSION.CONVERSATION_ID)
    removeCookie(cookieConstant.SESSION.CREATED_AT)
  }

  restartConversation() {
    removeCookie(cookieConstant.SESSION.CREATED_AT)
  }

  updateConversation() {
    this.createdAt = new Date().getTime()
    this.idleTimeout = getIdleTimeout()
    updateCookie(this.conversationId, this.createdAt, this.idleTimeout)
  }
}

function compareDates(t1, t2, timeout) {
  return Math.abs(t1 - t2) >= timeout
}

function updateCookie(conversationId, createdAt, idleTimeout) {
  setCookie(cookieConstant.SESSION.CONVERSATION_ID, conversationId, isUserLoggedIn() ? {} : {
    'max-age': idleTimeout / 1000
  })
  setCookie(cookieConstant.SESSION.CREATED_AT, createdAt, isUserLoggedIn() ? {} : {
    'max-age': idleTimeout / 1000
  })
}

export default new Session()
